<template>
  <div class="basic-container" ref="basiContainer">
    <div class="search-box" :class="{'search-box-has': $slots.head}">
      <slot name="head">
      </slot>
    </div>
    <div class="nedd-post set_style">
      <el-card shadow="never" class="box-card set_style" ref="boxCard" v-infinite-scroll="loadMore">
        <slot></slot>
        <div class="basiCont" v-loading="more">
        </div>
      </el-card>
    </div>
    <div class="footer-box">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "basicContainer",
  props: {
    more: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    needBorder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      erd: '',
      isFixed: false,
      timer: '',
      isHas: false
    }
  },
  mounted() {
    this.$refs.boxCard.$el.addEventListener('scroll', this.addlistent)
  },
  beforeDestroy() {
    this.$refs.boxCard.$el.removeEventListener('scroll', this.addlistent);
  },
  methods: {
    addlistent(e) {
      this.$emit('onscroll', this.$refs.boxCard.$el.scrollTop)
      this.$emit('scroll', e)
    },
    loadMore() {
      this.$emit('loadMore')
    },
  }
};
</script>

<style lang="scss">
.basic-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .search-box {
    background-color: #fff;
    position: relative;
    z-index: 3;
    flex-shrink: 0;
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 12px;
      box-shadow: 0px 5px 8px -3px rgba(13, 31, 60, 0.13);
    }
    .el-tabs__item {
      font-size: 14px;
    }
    .el-tabs__item.is-active {
      font-size: 14px;
    }
    &.search-box-has {
      min-height: 54px;
    }
  }

  .el-card {
    box-sizing: border-box;
    overflow: overlay;
    overflow: auto;
    border: 0 none;
    background: initial;
  }

  .el-card__body {
    padding: 0;
    height: 100%;
  }
  &:first-child {
    padding-top: 0;
  }
  .box-card-par {
    display: inline-block;
    font-size: 14px;
    height: 20px;
    line-height: 1;
    border-left: 5px solid #409eff;
    padding-left: 5px;
    padding-top: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: 600;
  }
  .nedd-post {
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    border: 1px solid #e7e8ed;
    background: #f8f9fb;
    z-index: 1;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    .box-card {
      height: 100%;
    }
  }
  .set_style {
    border: 0 none;
    background: rgba(255, 255, 255, 0);
    border-radius: 0;
  }
  .clearFixed {
    overflow: hidden;
  }
  .footer-box {
    flex-shrink: 0;
  }
}
</style>
